var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"data-app":""}},[(_vm.label)?_c('label',{staticClass:"input__label"},[_vm._v(_vm._s(_vm.label))]):_vm._e(),_c('v-slider',{attrs:{"tick-labels":_vm.options,"max":3,"step":"1","ticks":"always","tick-size":"4","inverse-label":true},model:{value:(_vm.v),callback:function ($$v) {_vm.v=$$v},expression:"v"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }